import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/aevos/Logo";
import { ChevronRight, Instagram, Mail, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-black text-white" data-testid="site-footer">
      <div className="aevos-container pt-8 pb-12 md:pt-10 md:pb-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <img
            src="/assets/aevos-horizontal-light-v2.svg"
            alt="AEVOS — Ciência que multiplica vida"
            className="h-9 w-auto"
            draggable={false}
          />
          <p className="mt-4 text-sm text-white/70 max-w-xs">
            <span className="text-[#00C4FF]">Ciência que multiplica vida.</span> Medicina preventiva, performance e longevidade
            em Mogi das Cruzes e Alto Tietê. <strong className="font-semibold text-white">Atendimento online</strong> em todo Brasil.
          </p>
        </div>

        <div>
          <h4 className="font-display text-sm tracking-[0.18em] uppercase text-[#00C4FF] mb-4">
            Navegação
          </h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/sobre" className="inline-flex items-center gap-2 hover:text-[#00C4FF] group" data-testid="footer-link-sobre"><ChevronRight size={14} className="text-[#00C4FF] transition-transform group-hover:translate-x-0.5" />Sobre o Dr. Guilherme</Link></li>
            <li><Link to="/metodo" className="inline-flex items-center gap-2 hover:text-[#00C4FF] group" data-testid="footer-link-metodo"><ChevronRight size={14} className="text-[#00C4FF] transition-transform group-hover:translate-x-0.5" />Método AEVOS</Link></li>
            <li><Link to="/planos" className="inline-flex items-center gap-2 hover:text-[#00C4FF] group" data-testid="footer-link-planos"><ChevronRight size={14} className="text-[#00C4FF] transition-transform group-hover:translate-x-0.5" />Planos &amp; Investimento</Link></li>
            <li><Link to="/tecnologia" className="inline-flex items-center gap-2 hover:text-[#00C4FF] group" data-testid="footer-link-tecnologia"><ChevronRight size={14} className="text-[#00C4FF] transition-transform group-hover:translate-x-0.5" />Tecnologia &amp; Exames</Link></li>
            <li><Link to="/mapeamento" className="inline-flex items-center gap-2 hover:text-[#00C4FF] group" data-testid="footer-link-mapeamento"><ChevronRight size={14} className="text-[#00C4FF] transition-transform group-hover:translate-x-0.5" />Mapeamento Metabólico IA</Link></li>
            <li><Link to="/parcerias" className="inline-flex items-center gap-2 hover:text-[#00C4FF] group" data-testid="footer-link-parcerias"><ChevronRight size={14} className="text-[#00C4FF] transition-transform group-hover:translate-x-0.5" />Parcerias B2B</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm tracking-[0.18em] uppercase text-[#00C4FF] mb-4">
            Contato
          </h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-2">
              <MapPin size={16} className="mt-0.5 text-[#00C4FF]" />
              <span>R. Waldemar Zierold, 23 — Vila Sarah Avignon<br/>Mogi das Cruzes — SP · CEP 08773-470<br/><span className="text-[#00C4FF]">Atendimento presencial e online.</span></span>
            </li>
            <li className="flex items-center gap-2">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="text-[#00C4FF]"><path d="M20.52 3.48A11.86 11.86 0 0 0 12 0 12 12 0 0 0 1.6 17.93L0 24l6.21-1.63A11.93 11.93 0 0 0 12 24a12 12 0 0 0 8.52-20.52ZM12 21.84a9.85 9.85 0 0 1-5-1.36l-.36-.22-3.69.97.98-3.6-.24-.37A9.86 9.86 0 1 1 12 21.84Zm5.43-7.42c-.3-.15-1.77-.87-2-.97s-.46-.15-.66.15-.76.97-.93 1.17-.34.22-.64.07a8.05 8.05 0 0 1-2.36-1.46 8.92 8.92 0 0 1-1.64-2.04c-.17-.3 0-.46.13-.6s.3-.34.45-.51a2 2 0 0 0 .3-.5.55.55 0 0 0 0-.52c-.07-.15-.66-1.6-.9-2.18s-.48-.5-.66-.5h-.57a1.1 1.1 0 0 0-.8.37 3.34 3.34 0 0 0-1.04 2.49 5.8 5.8 0 0 0 1.22 3.07 13.27 13.27 0 0 0 5.07 4.49c.71.3 1.26.49 1.7.63a4.1 4.1 0 0 0 1.86.12 3.05 3.05 0 0 0 2-1.42 2.5 2.5 0 0 0 .17-1.42c-.07-.13-.27-.2-.57-.35Z"/></svg>
              <a href="https://wa.me/5511941546532" target="_blank" rel="noreferrer" className="hover:text-[#00C4FF]" data-testid="footer-whatsapp">
                (11) 94154-6532
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Instagram size={16} className="text-[#00C4FF]" />
              <a href="https://instagram.com/drguilherme.affonso" target="_blank" rel="noreferrer" className="hover:text-[#00C4FF]">
                @drguilherme.affonso
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={16} className="text-[#00C4FF]" />
              <a href="mailto:contato@aevos.com.br" className="hover:text-[#00C4FF]">contato@aevos.com.br</a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm tracking-[0.18em] uppercase text-[#00C4FF] mb-4">
            Responsável Técnico
          </h4>
          <p className="text-sm text-white/80">
            <strong className="text-white">Dr. Guilherme Affonso</strong><br/>
            CRM-SP 200364 · RQE 120948<br/>
            <span className="block mt-2">Especialidade: Medicina Preventiva e Social <span className="text-white/60">(Residência no Hospital Sírio-Libanês)</span></span>
            <span className="block mt-2">Atuação clínica: Medicina do Esporte, Anabolismo Clínico, Hormônios e Saúde da Mulher</span>
            <span className="block mt-2 text-[#00C4FF]">Foco: Otimização metabólica, performance física, composição corporal e longevidade</span>
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="aevos-container py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Clínica AEVOS — Ciência que multiplica vida. Todos os direitos reservados.</p>
          <div className="flex gap-4">
            <Link to="/contato" className="hover:text-white">Política de Privacidade</Link>
            <Link to="/contato" className="hover:text-white">Termos de Uso</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
